import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rounded-lg shadow bg-white p-4" }
const _hoisted_2 = { class: "flex justify-between items-center mb-4" }
const _hoisted_3 = { class: "flex gap-2" }
const _hoisted_4 = { class: "flex gap-2 mb-4" }
const _hoisted_5 = { class: "flex gap-2 mb-3" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "badge bg-secondary" }
const _hoisted_10 = { class: "flex gap-1 flex-wrap" }
const _hoisted_11 = ["disabled", "onClick"]
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_16 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex justify-between items-center mb-4" }
const _hoisted_20 = { class: "font-bold text-xl" }
const _hoisted_21 = { class: "template-editor-grid" }
const _hoisted_22 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "text-danger text-sm"
}
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  class: "grid grid-cols-2 gap-3 mt-3"
}
const _hoisted_27 = { class: "mt-3" }
const _hoisted_28 = { class: "border rounded p-3 bg-gray-50 mb-2" }
const _hoisted_29 = { class: "flex flex-wrap gap-2" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_32 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_33 = { class: "mt-3" }
const _hoisted_34 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_35 = ["value"]
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["value"]
const _hoisted_38 = {
  key: 0,
  class: "text-sm text-gray-500 mt-1"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "mt-4" }
const _hoisted_42 = { class: "flex justify-between items-center mb-2" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_45 = ["onUpdate:modelValue", "disabled", "onChange"]
const _hoisted_46 = ["value"]
const _hoisted_47 = ["onUpdate:modelValue", "disabled"]
const _hoisted_48 = {
  key: 0,
  class: "grid grid-cols-2 gap-2 mt-2"
}
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = {
  key: 1,
  class: "grid grid-cols-2 gap-2 mt-2"
}
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = { class: "flex justify-end mt-2" }
const _hoisted_55 = ["disabled", "onClick"]
const _hoisted_56 = { class: "template-preview sticky top-3" }
const _hoisted_57 = {
  key: 0,
  class: "border-bottom pb-2 mb-2"
}
const _hoisted_58 = { class: "font-bold text-lg" }
const _hoisted_59 = { class: "text-sm" }
const _hoisted_60 = { class: "whitespace-pre-wrap mb-0" }
const _hoisted_61 = {
  key: 1,
  class: "text-sm text-gray-500 mt-3"
}
const _hoisted_62 = {
  key: 2,
  class: "text-sm text-gray-500 mt-3"
}
const _hoisted_63 = {
  key: 3,
  class: "mt-3 grid gap-2"
}
const _hoisted_64 = {
  key: 0,
  class: "alert alert-warning mt-3 mb-0"
}
const _hoisted_65 = {
  key: 1,
  class: "alert alert-danger mt-3 mb-0"
}
const _hoisted_66 = { class: "flex justify-between mt-3" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "flex gap-2" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_71 = { class: "whitespace-pre-wrap" }
const _hoisted_72 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.editorMode)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[36] || (_cache[36] = _createElementVNode("h1", { class: "font-bold text-xl" }, "알림톡 관리", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sync && _ctx.sync(...args)))
              }, "템플릿 전체 동기화"),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCreate && _ctx.openCreate(...args)))
              }, "템플릿 등록")
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn", _ctx.tab === 'templates' ? 'btn-primary' : 'btn-outline-primary']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 'templates'))
            }, "템플릿 관리", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["btn", _ctx.tab === 'bulk' ? 'btn-primary' : 'btn-outline-primary']),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tab = 'bulk'))
            }, "대량 발송", 2)
          ]),
          (_ctx.tab === 'templates')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.keyword) = $event)),
                    class: "form-control max-w-sm",
                    placeholder: "코드 또는 이름 검색",
                    onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.keyword]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.managementTypeFilter) = $event)),
                    class: "form-select max-w-sm"
                  }, [
                    _cache[37] || (_cache[37] = _createElementVNode("option", { value: "" }, "전체 타입", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managementTypes, (type) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: type.value,
                        value: type.value
                      }, _toDisplayString(type.label), 9, _hoisted_6))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.managementTypeFilter]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-secondary",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
                  }, "검색")
                ]),
                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "text-sm text-gray-500 mb-2" }, "사용 중인 템플릿 우선, 같은 사용 여부에서는 최근 등록 순으로 표시됩니다.", -1)),
                _createVNode(_component_b_table, {
                  items: _ctx.templates,
                  fields: _ctx.fields,
                  responsive: "",
                  hover: ""
                }, {
                  "cell(templateCode)": _withCtx((d) => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-link p-0 text-left",
                      onClick: ($event: any) => (_ctx.openDetail(d.item))
                    }, _toDisplayString(d.item.templateCode), 9, _hoisted_7)
                  ]),
                  "cell(templateName)": _withCtx((d) => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-link p-0 text-left",
                      onClick: ($event: any) => (_ctx.openDetail(d.item))
                    }, _toDisplayString(d.item.templateName), 9, _hoisted_8)
                  ]),
                  "cell(managementButtonName)": _withCtx((d) => [
                    _createElementVNode("span", null, _toDisplayString(d.item.managementButtonName || '-'), 1)
                  ]),
                  "cell(templateStatusName)": _withCtx((d) => [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(d.item.templateStatusName || d.item.templateStatus), 1)
                  ]),
                  "cell(inUse)": _withCtx((d) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", d.item.inUse ? 'bg-success' : 'bg-secondary'])
                    }, _toDisplayString(d.item.inUse ? '사용 중' : '미사용'), 3)
                  ]),
                  "cell(actions)": _withCtx((d) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn btn-sm", d.item.inUse ? 'btn-outline-danger' : 'btn-outline-success']),
                        disabled: _ctx.usingId === d.item.id,
                        onClick: _withModifiers(($event: any) => (_ctx.toggleInUse(d.item)), ["stop"])
                      }, _toDisplayString(_ctx.usingId === d.item.id ? '처리 중' : d.item.inUse ? '사용 해제' : '사용 처리'), 11, _hoisted_11),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-secondary",
                        disabled: _ctx.syncingCode === d.item.templateCode,
                        onClick: _withModifiers(($event: any) => (_ctx.refreshRow(d.item)), ["stop"])
                      }, _toDisplayString(_ctx.syncingCode === d.item.templateCode ? '동기화 중' : '새로고침'), 9, _hoisted_12),
                      (_ctx.canDelete(d.item))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-sm btn-outline-danger",
                            disabled: _ctx.deletingId === d.item.id,
                            onClick: _withModifiers(($event: any) => (_ctx.removeRow(d.item)), ["stop"])
                          }, _toDisplayString(_ctx.deletingId === d.item.id ? '삭제 중' : '삭제'), 9, _hoisted_13))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["items", "fields"])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "alert alert-warning" }, "발송 후 취소할 수 없습니다. 대상과 치환 내용을 확인한 뒤 발송하세요.", -1)),
                _cache[42] || (_cache[42] = _createElementVNode("label", { class: "font-semibold" }, "승인 템플릿", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bulkTemplateId) = $event)),
                  class: "form-select mb-3"
                }, [
                  _cache[39] || (_cache[39] = _createElementVNode("option", { value: "" }, "선택", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approved, (t) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: t.id,
                      value: t.id
                    }, _toDisplayString(t.managementButtonName || t.templateName) + " (" + _toDisplayString(t.templateCode) + ")", 9, _hoisted_14))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.bulkTemplateId]
                ]),
                _cache[43] || (_cache[43] = _createElementVNode("label", { class: "font-semibold" }, "CSV/엑셀 파일", -1)),
                _createElementVNode("input", {
                  type: "file",
                  accept: ".csv,.xlsx,.xls",
                  class: "form-control mb-3",
                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args)))
                }, null, 32),
                _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-gray-500" }, "첫 행에 name, code, phonenumber 헤더를 넣어주세요. 최대 5,000명까지 업로드되며 1,000명씩 나누어 발송됩니다.", -1)),
                (_ctx.missingHeaders.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[40] || (_cache[40] = _createTextVNode("엑셀에 필요한 헤더가 없습니다: ")),
                      _createElementVNode("b", null, _toDisplayString(_ctx.missingHeaders.join(', ')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.requiredParameters.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, "선택한 템플릿 치환값: " + _toDisplayString(_ctx.requiredParameters.join(', ')), 1))
                  : _createCommentVNode("", true),
                (_ctx.recipients.length)
                  ? (_openBlock(), _createBlock(_component_b_table, {
                      key: 2,
                      items: _ctx.recipients,
                      fields: ['row', 'phoneNumber', 'templateParameters'],
                      responsive: ""
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  disabled: !_ctx.bulkTemplateId || !_ctx.recipients.length || _ctx.missingHeaders.length > 0 || _ctx.sending,
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.sendBulk && _ctx.sendBulk(...args)))
                }, _toDisplayString(_ctx.recipients.length) + "명 발송하기", 9, _hoisted_17)
              ], 64))
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-link px-0 mb-2",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goList && _ctx.goList(...args)))
              }, "← 템플릿 목록"),
              _createElementVNode("h1", _hoisted_20, _toDisplayString(_ctx.form.id ? '템플릿 상세/수정' : '템플릿 등록'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", null, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", { class: "required-label" }, "템플릿 코드", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.templateCode) = $event)),
                    disabled: !!_ctx.form.id,
                    maxlength: "20",
                    class: _normalizeClass(["form-control", {'is-invalid': _ctx.codeError}])
                  }, null, 10, _hoisted_23), [
                    [_vModelText, _ctx.form.templateCode]
                  ]),
                  _cache[46] || (_cache[46] = _createElementVNode("small", { class: "text-gray-500" }, "20자 이내 영문, 숫자, _, -만 사용 · 중복 불가", -1)),
                  (_ctx.codeError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.codeError), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[47] || (_cache[47] = _createElementVNode("label", { class: "required-label" }, "템플릿 이름", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.templateName) = $event)),
                    maxlength: "150",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.form.templateName]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[49] || (_cache[49] = _createElementVNode("label", { class: "required-label" }, "내부 관리 타입", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.managementType) = $event)),
                    class: "form-select"
                  }, [
                    _cache[48] || (_cache[48] = _createElementVNode("option", {
                      value: null,
                      disabled: ""
                    }, "선택해주세요", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managementTypes, (type) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: type.value,
                        value: type.value
                      }, _toDisplayString(type.label), 9, _hoisted_25))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.managementType]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[50] || (_cache[50] = _createElementVNode("label", { class: "required-label" }, "카톡 관리 버튼명", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.managementButtonName) = $event)),
                    maxlength: "100",
                    class: "form-control",
                    placeholder: "대량발송 모달에 표시할 이름"
                  }, null, 512), [
                    [_vModelText, _ctx.form.managementButtonName]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[52] || (_cache[52] = _createElementVNode("label", { class: "required-label" }, "메시지 유형", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.templateMessageType) = $event)),
                    class: "form-select",
                    onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.normalizeMessageType && _ctx.normalizeMessageType(...args)))
                  }, _cache[51] || (_cache[51] = [
                    _createElementVNode("option", { value: "BA" }, "기본형", -1),
                    _createElementVNode("option", { value: "EX" }, "부가 정보형", -1),
                    _createElementVNode("option", { value: "AD" }, "채널 추가형", -1),
                    _createElementVNode("option", { value: "MI" }, "복합형", -1)
                  ]), 544), [
                    [_vModelSelect, _ctx.form.templateMessageType]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[54] || (_cache[54] = _createElementVNode("label", { class: "required-label" }, "템플릿 강조 유형", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.templateEmphasizeType) = $event)),
                    class: "form-select"
                  }, _cache[53] || (_cache[53] = [
                    _createElementVNode("option", { value: "NONE" }, "선택 안 함", -1),
                    _createElementVNode("option", { value: "TEXT" }, "강조 표기형", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.form.templateEmphasizeType]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[56] || (_cache[56] = _createElementVNode("label", { class: "required-label" }, "보안 템플릿 여부", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.securityFlag) = $event)),
                    class: "form-select"
                  }, _cache[55] || (_cache[55] = [
                    _createElementVNode("option", { value: false }, "미설정", -1),
                    _createElementVNode("option", { value: true }, "설정", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.form.securityFlag]
                  ])
                ])
              ]),
              (_ctx.form.templateEmphasizeType === 'TEXT')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", null, [
                      _cache[57] || (_cache[57] = _createElementVNode("label", { class: "required-label" }, "템플릿 강조 제목", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.templateTitle) = $event)),
                        maxlength: "50",
                        class: "form-control",
                        placeholder: "최대 2줄 23자 권장"
                      }, null, 512), [
                        [_vModelText, _ctx.form.templateTitle]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[58] || (_cache[58] = _createElementVNode("label", { class: "required-label" }, "템플릿 강조 부제목", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.templateSubtitle) = $event)),
                        maxlength: "50",
                        class: "form-control",
                        placeholder: "치환 불가, 최대 2줄 18자 권장"
                      }, null, 512), [
                        [_vModelText, _ctx.form.templateSubtitle]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _cache[60] || (_cache[60] = _createElementVNode("label", { class: "required-label" }, "템플릿 내용", -1)),
                _createElementVNode("div", _hoisted_28, [
                  _cache[59] || (_cache[59] = _createElementVNode("div", { class: "text-sm font-semibold mb-2" }, "치환값 넣기", -1)),
                  _createElementVNode("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variables, (v) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: v.key,
                        type: "button",
                        class: "btn btn-sm btn-outline-secondary",
                        onClick: ($event: any) => (_ctx.insertVariable(v.key))
                      }, _toDisplayString(v.label) + " " + _toDisplayString(_ctx.variableToken(v.key)), 9, _hoisted_30))
                    }), 128))
                  ])
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  ref: "templateContent",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.templateContent) = $event)),
                  rows: "12",
                  maxlength: "1300",
                  class: "form-control",
                  placeholder: "변수는 #{변수} 형태로 입력"
                }, null, 512), [
                  [_vModelText, _ctx.form.templateContent]
                ])
              ]),
              (_ctx.needsExtra)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _cache[61] || (_cache[61] = _createElementVNode("label", { class: "required-label" }, "부가 정보", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.templateExtra) = $event)),
                      rows: "3",
                      maxlength: "500",
                      class: "form-control",
                      placeholder: "치환 변수 사용 불가, URL 포함 가능, 최대 500자"
                    }, null, 512), [
                      [_vModelText, _ctx.form.templateExtra]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.needsChannel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _cache[62] || (_cache[62] = _createElementVNode("label", { class: "required-label" }, "채널 추가 안내 메시지", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.templateAd) = $event)),
                      rows: "3",
                      maxlength: "80",
                      class: "form-control",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.form.templateAd]
                    ]),
                    _cache[63] || (_cache[63] = _createElementVNode("small", { class: "text-danger" }, "채널 추가 버튼은 첫 번째에 자동으로 고정됩니다.", -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_33, [
                _cache[66] || (_cache[66] = _createElementVNode("label", { class: "required-label" }, "카테고리", -1)),
                _createElementVNode("div", _hoisted_34, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.selectedCategoryName) = $event)),
                    class: "form-select",
                    onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.categoryCode = ''))
                  }, [
                    _cache[64] || (_cache[64] = _createElementVNode("option", { value: "" }, "대분류 선택", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: category.name,
                        value: category.name
                      }, _toDisplayString(category.name), 9, _hoisted_35))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selectedCategoryName]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.categoryCode) = $event)),
                    class: "form-select",
                    disabled: !_ctx.selectedCategoryName
                  }, [
                    _cache[65] || (_cache[65] = _createElementVNode("option", { value: "" }, "중분류 선택", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSubCategories, (category) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: category.code,
                        value: category.code
                      }, _toDisplayString(category.name) + " (" + _toDisplayString(category.code) + ")", 9, _hoisted_37))
                    }), 128))
                  ], 8, _hoisted_36), [
                    [_vModelSelect, _ctx.form.categoryCode]
                  ])
                ]),
                (_ctx.selectedCategoryInfo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      (_ctx.selectedCategoryInfo.inclusion)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, "적용 대상: " + _toDisplayString(_ctx.selectedCategoryInfo.inclusion), 1))
                        : _createCommentVNode("", true),
                      (_ctx.selectedCategoryInfo.exclusion)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, "제외 대상: " + _toDisplayString(_ctx.selectedCategoryInfo.exclusion), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _cache[67] || (_cache[67] = _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-semibold" }, "버튼"),
                    _createElementVNode("span", { class: "text-sm text-gray-500 ml-2" }, "최대 5개")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-primary",
                    disabled: _ctx.form.buttons.length >= 5,
                    onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.addButton && _ctx.addButton(...args)))
                  }, "버튼 추가", 8, _hoisted_43)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.buttons, (button, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "border rounded p-3 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", null, [
                        _cache[68] || (_cache[68] = _createElementVNode("label", null, "타입", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((button.type) = $event),
                          class: "form-select",
                          disabled: _ctx.needsChannel && index === 0,
                          onChange: ($event: any) => (_ctx.normalizeButton(button))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttonTypes, (type) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: type.value,
                              value: type.value
                            }, _toDisplayString(type.label), 9, _hoisted_46))
                          }), 128))
                        ], 40, _hoisted_45), [
                          [_vModelSelect, button.type]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[69] || (_cache[69] = _createElementVNode("label", { class: "required-label" }, "버튼 이름", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((button.name) = $event),
                          maxlength: "14",
                          class: "form-control",
                          disabled: button.type === 'AC'
                        }, null, 8, _hoisted_47), [
                          [_vModelText, button.name]
                        ])
                      ])
                    ]),
                    (button.type === 'WL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((button.linkMo) = $event),
                            maxlength: "500",
                            class: "form-control",
                            placeholder: "Mobile URL (필수)"
                          }, null, 8, _hoisted_49), [
                            [_vModelText, button.linkMo]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((button.linkPc) = $event),
                            maxlength: "500",
                            class: "form-control",
                            placeholder: "PC URL"
                          }, null, 8, _hoisted_50), [
                            [_vModelText, button.linkPc]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (button.type === 'AL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((button.schemeAndroid) = $event),
                            maxlength: "500",
                            class: "form-control",
                            placeholder: "Android scheme"
                          }, null, 8, _hoisted_52), [
                            [_vModelText, button.schemeAndroid]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((button.schemeIos) = $event),
                            maxlength: "500",
                            class: "form-control",
                            placeholder: "iOS scheme"
                          }, null, 8, _hoisted_53), [
                            [_vModelText, button.schemeIos]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-danger",
                        disabled: _ctx.needsChannel && index === 0,
                        onClick: ($event: any) => (_ctx.removeButton(index))
                      }, "삭제", 8, _hoisted_55)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_56, [
                _cache[71] || (_cache[71] = _createElementVNode("div", { class: "font-semibold mb-3" }, "치환 미리보기", -1)),
                (_ctx.form.templateEmphasizeType === 'TEXT')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _cache[70] || (_cache[70] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "강조 표기", -1)),
                      _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.form.templateTitle || '강조 제목'), 1),
                      _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.form.templateSubtitle || '강조 부제목'), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("pre", _hoisted_60, _toDisplayString(_ctx.templatePreview || '템플릿 내용을 입력해주세요.'), 1),
                (_ctx.needsExtra)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.form.templateExtra || '부가 정보'), 1))
                  : _createCommentVNode("", true),
                (_ctx.needsChannel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.form.templateAd), 1))
                  : _createCommentVNode("", true),
                (_ctx.form.buttons.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.buttons, (button, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: index,
                          type: "button",
                          class: "btn btn-light border",
                          disabled: ""
                        }, _toDisplayString(button.name || '버튼 이름'), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.form.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, "목록의 ‘사용 처리’ 버튼으로 실제 사용 여부를 변경할 수 있습니다. 타입 1~4는 타입별 한 개만 사용할 수 있으며 NHN 승인 완료 상태여야 합니다."))
            : _createCommentVNode("", true),
          (_ctx.formError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.formError), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", null, [
              (_ctx.form.id && _ctx.canDelete(_ctx.form))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-outline-danger",
                    disabled: _ctx.deletingId === _ctx.form.id,
                    onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
                  }, _toDisplayString(_ctx.deletingId === _ctx.form.id ? '삭제 중' : '삭제'), 9, _hoisted_67))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_68, [
              (_ctx.form.id)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-outline-secondary",
                    onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.refreshDetail && _ctx.refreshDetail(...args)))
                  }, "템플릿 동기화"))
                : _createCommentVNode("", true),
              (_ctx.form.id)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-outline-dark",
                    onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.saveManagement && _ctx.saveManagement(...args)))
                  }, "운영 타입 저장"))
                : _createCommentVNode("", true),
              (_ctx.form.id)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-outline-success",
                    onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.openTest && _ctx.openTest(...args)))
                  }, "테스트 발송"))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: !!_ctx.formError,
                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, _toDisplayString(_ctx.form.id ? '수정 검수 요청' : '등록 및 검수 요청'), 9, _hoisted_69)
            ])
          ]),
          (_ctx.form.modifications && _ctx.form.modifications.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _cache[72] || (_cache[72] = _createElementVNode("h3", { class: "font-bold" }, "수정 검수 이력", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.modifications, (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: m.id,
                    class: "border rounded p-2 mt-2"
                  }, [
                    _createElementVNode("b", null, _toDisplayString(m.templateStatusName || m.templateStatus), 1),
                    _createElementVNode("pre", _hoisted_71, _toDisplayString(m.templateContent), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.showTest,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.showTest) = $event)),
      title: "알림톡 테스트 발송",
      onOk: _ctx.testSend
    }, {
      default: _withCtx(() => [
        _cache[73] || (_cache[73] = _createElementVNode("label", null, "수신 전화번호", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.test.recipientNumber) = $event)),
          class: "form-control mb-2"
        }, null, 512), [
          [_vModelText, _ctx.test.recipientNumber]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.templateParameters, (key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "mb-2"
          }, [
            _createElementVNode("label", null, _toDisplayString(_ctx.variableToken(key)), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((_ctx.test.parameters[key]) = $event),
              class: "form-control"
            }, null, 8, _hoisted_72), [
              [_vModelText, _ctx.test.parameters[key]]
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "onOk"])
  ]))
}